import { BaseCard } from "./BaseCard.js";
import { CardHeader } from "./internal/CardHeader.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/card/ElevatedCard.tsx
const ElevatedCard = ({ children, footer, header, Icon, iconColor, onClick, "data-testid": testId, role, sharp = false, fullWidthFooter = false, pinFooter, fullHeight }) => {
	return /* @__PURE__ */ jsx(BaseCard, {
		onClick,
		footer,
		fullWidthFooter,
		pinFooter,
		fullHeight,
		header: header ? /* @__PURE__ */ jsx(CardHeader, { children: header }) : null,
		Icon,
		iconColor,
		shadow: "xs",
		variant: "filled",
		padding: "sm",
		radius: sharp ? "0" : "sm",
		"data-testid": testId,
		role,
		children
	});
};

//#endregion
export { ElevatedCard };